import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetVaccineDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Vaccine/GetDetail?` + params, null);

export const GetVaccineList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Vaccine/GetList?` + params, null);

export const CreateVaccine = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Vaccine/Create`, data);

export const UpdateVaccine = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Vaccine/Update`, data);    

export const DeleteVaccine = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Vaccine/Delete`, data);

